import { useEffect, useState } from "react";
import { Navbar } from "react-bootstrap";
import SimpleRenovate from "../../../assets/images/4.png";
import { useLocation, useNavigate } from "react-router-dom";
import logout from "../../../assets/img/logout mssg noti.svg";
import { isMobilePublicAuthPath } from "../../../Helper/authSession";
import { hasMobileRedirectionSession } from "../../../Helper/mobileAuth";

const Header = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    const isLoggedIn = hasMobileRedirectionSession();
    const isPublicAuthPage = isMobilePublicAuthPath(location.pathname);

    if (isLoggedIn) {
      setShowDropdown(true);
      if (isPublicAuthPage) {
        navigation("/manage-dashboard", { replace: true });
      }
    } else {
      setShowDropdown(false);
      if (!isPublicAuthPage) {
        navigation("/get-started", { replace: true });
        handleViewDetails();
      }
    }
  }, [location.pathname, navigation]);

  const handleLogout = () => {
    localStorage.clear();
    handleViewDetails();
    navigation("/get-started", { replace: true });
  };

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Navbar
      expand="lg"
      bg="white"
      className="nav-bar-width py-2 py-lg-3 navbar navbar_common navbar-expand-lg navbar-light bg-white"
    >
      <div className="custom_container d-flex justify-content-between align-items-center">
        <div className="nav-width nav_width_lg d-flex align-items-center">
          <div className="img_toggle_btn me-3">
            <p
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleViewDetails();
                if (hasMobileRedirectionSession()) {
                  navigation("/manage-dashboard");
                } else {
                  navigation("/login");
                }
              }}
              className="me-0 mb-0"
            >
              <img
                src={SimpleRenovate}
                alt="Simple Renovate"
                className="navbar-logo"
              />
            </p>
          </div>
        </div>
        {showDropdown && (
          <div className="d-flex align-items-center position-relative">
            <button
              className="btn border-0"
              onClick={handleLogout}
              style={{ color: "#cc4645" }}
            >
              <img
                src={logout}
                alt="Logout"
                style={{ width: 16, height: 16, marginRight: 8 }}
              />
              Logout
            </button>
          </div>
        )}
      </div>
    </Navbar>
  );
};

export default Header;
